import React from 'react';
import { Helmet } from 'react-helmet-async';
import imageSrc from './images/66_HUND MAN_023 Large.jpeg';

const Home = () => {
    return (
        <>
        <Helmet>
            <title>Alessandro Iovino - Professional Photographer Portfolio</title>
            <meta name="description" content="Professional photography portfolio showcasing commercial work, fine art prints, and editorial photography by Alessandro Iovino." />
            <meta property="og:title" content="Alessandro Iovino - Professional Photographer Portfolio" />
            <meta property="og:description" content="Professional photography portfolio showcasing commercial work, fine art prints, and editorial photography." />
            <link rel="canonical" href="https://alessandroiovino.com" />
        </Helmet>
        <div className="home-picture-gallery">
            <div className="solo-item">
                <h1 className="sr-only">Alessandro Iovino</h1>
                <p className="sr-only">Professional Photographer</p>
                <img src={imageSrc} alt="Professional photography portfolio by Alessandro Iovino featuring commercial and fine art photography"/>
            </div>
        </div>
        </>
    );
}

export default Home;